import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Input, Icon, Select, SelectItem, IndexPath, CheckBox } from '@ui-kitten/components';
import { StyleSheet, ScrollView } from 'react-native';
import { useDispatch, useSelector} from 'react-redux';
import {setCustumerProblem, setReqType, setCategory, setModel, setMaq} from '../../../store/actions/newAddress'
import trackerApi from '../../api/tracker';


const AgentIcon = (props) => (
  <Icon {...props} name='smiling-face'/>
);

const PhoneIcon = (props) => (
  <Icon {...props} name='phone-call'/>
);

const MapIcon = (props) => (
  <Icon {...props} name='map'/>
);

const EditIcon = (props) => (
  <Icon {...props} name='edit'/>
);

const serviceType = [
  'نصب و راه اندازی',
  'تعمیر'
]

const category = [
  'در بازکن تصویری',
  'در بازکن کنترلی'
]

const model = [
  [],
  []
]

export const ServiceInfo = ({ navigation }) => {
  const [serviceSelectedIndex, setServiceSelectedIndex] = React.useState(new IndexPath(0));
  const [catIndex, setCatIndex] = React.useState(new IndexPath(0));
  const [modelIndex, setModelIndex] = React.useState(new IndexPath(0));
  const [serverModels, setServerModels] = React.useState([]);
  const dareMaqaze = useSelector( state => state.newAddress.dareMaqaze);
  const problem = useSelector( state => state.newAddress.problem);

  const dispatch = useDispatch();
  React.useEffect(()=>{
    getData();
  },[])
  const getData = async ()=>{
    model[0] = []
    model[1] = []
    const response = await trackerApi.post('/get/products');
    if(response.data.status) setServerModels(response.data.allData);
    response.data.allData.map((data)=>{
      if(data.product_cat==category[0]){
        model[0].push(data.product_name)
    } else if(data.product_cat==category[1]){
      model[1].push(data.product_name)
  }}
  )
  }

  const selectModel = async (index)=>{
    await setModelIndex(index);
    await dispatch(setModel(model[catIndex.row][index-1]))
  }

  const selectCategory = async (index)=>{
    await setCatIndex(index);
    await dispatch(setCategory(category[index-1]))
  }

  const selectType = async (index)=>{
    await setServiceSelectedIndex(index);
    await dispatch(setReqType(serviceType[index-1]))
  }

  return (
      <Layout level='3' style={{paddingHorizontal:15, marginVertical:5, paddingTop:5, paddingBottom:20, marginHorizontal:6, borderRadius:10}} >

          <Text category='c2' style={{marginTop:10}} appearance='hint'> نوع درخواست</Text>
          <Select
            selectedIndex={serviceSelectedIndex}
            value = {serviceType[serviceSelectedIndex.row]}
            onSelect={index => selectType(index)}>
            {
              serviceType.map((data)=>{
                return (
                  <SelectItem title={data} key={serviceSelectedIndex} />
                )
              })
            }
          </Select>

          <Text category='c2' style={{marginTop:10}} appearance='hint'> دسته بندی محصول</Text>
          <Select
            selectedIndex={catIndex}
            value = {category[catIndex.row]}
            onSelect={ index => {selectCategory(index)}}>
            {
              category.map((data)=>{
                return (
                  <SelectItem title={data} key={catIndex} />
                )
              })
            }
          </Select>

          <Text category='c2' style={{marginTop:10}} appearance='hint'> مدل دستگاه</Text>
          <Select
            selectedIndex={modelIndex}
            value = {model[catIndex.row][modelIndex-1]}
            onSelect={selectModel}>
            {

                // serverModels.map((data)=>{
                //   if(data.product_cat==category[catIndex.row]){
                //     return (
                //       <SelectItem title={data} key={modelIndex} />
                //     )
                //   }
                // })
              model[catIndex.row].map((data)=>{
                return (
                  <SelectItem title={data} key={modelIndex} />
                )
              })
            }

          </Select>

          <Text category='c2' style={{marginTop:10}} appearance='hint'> شرح مشکل</Text>
          <Input
            placeholder ='مشکل دستگاه'
            value={problem}
            accessoryLeft={EditIcon}
            multiline={true}
            onChangeText = {newValue =>{ dispatch(setCustumerProblem(newValue))}}
            />

            <CheckBox
              style={{ marginHorizontal:15, marginTop:20, marginBottom: 5}}
              checked={dareMaqaze}
              onChange={nextChecked => dispatch(setMaq(nextChecked))}>


              <Text category='h6'>
                 پذیرش درب مغازه
              </Text>

            </CheckBox>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
  },
});
